import radioGroup from '@/components/checkGroup/radioGroup'

export default {
  components: {
    radioGroup
  }
}
